"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.InventorySnapshotAPI = {
    getInventorySnapshots: function (companyId) { return index_1.axios.get("/api/v1/company/" + companyId + "/inventorySnapshots").then(function (response) {
        var snapshots = response.data.data;
        return snapshots;
    }); },
    getInventorySnapshotById: function (companyId, inventorySnapshotId) { return index_1.axios.get("/api/v1/company/" + companyId + "/inventorySnapshot/" + inventorySnapshotId).then(function (response) {
        var snapshot = response.data;
        return snapshot;
    }); },
    createInventorySnapshot: function (companyId, locationId) { return index_1.axios.post("/api/v1/company/" + companyId + "/inventorySnapshot", {
        locationId: locationId,
    }).then(function (response) {
        var snapshot = response.data;
        return snapshot;
    }); },
};
//# sourceMappingURL=InventorySnapshotAPI.js.map